module.exports = __webpack_public_path__ + "static/img/gaozhongdili2.9b3d2789.jpg";